"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignParserFromContent = void 0;
const checkType_1 = __importStar(require("../checkType"));
const parser_1 = __importStar(require("../parser"));
const filterAlign_1 = __importDefault(require("../filterAlign"));
const error_1 = require("../utils/error");
const alignParser = (fileName, filterAlignOpt) => __awaiter(void 0, void 0, void 0, function* () {
    const { alignType, parserOpt } = yield (0, checkType_1.default)(fileName);
    const parser = (0, error_1.withErrorConsole)((0, parser_1.parserCreater)(parserOpt, fileName));
    const filter = (0, parser_1.filterCreater)(parserOpt ? parserOpt.filters : null);
    const filterAlign = filterAlignOpt
        ? (0, filterAlign_1.default)(filterAlignOpt)
        : null;
    const { alignments, alignmentsByCtgs, lenInfo } = yield (0, parser_1.default)(fileName, parser, filter, filterAlign);
    return { alignType, alignments, alignmentsByCtgs, lenInfo };
});
const alignParserFromContent = (content, filterAlignOpt) => {
    const { alignType, parserOpt } = (0, checkType_1.checkTypeFromContent)(content);
    const parser = (0, parser_1.parserCreater)(parserOpt, 'input alignments');
    const filter = (0, parser_1.filterCreater)(parserOpt ? parserOpt.filters : null);
    const filterAlign = filterAlignOpt
        ? (0, filterAlign_1.default)(filterAlignOpt)
        : null;
    const { alignments, alignmentsByCtgs, lenInfo } = (0, parser_1.parseAlignFromContent)(content, parser, filter, filterAlign);
    return { alignType, alignments, alignmentsByCtgs, lenInfo };
};
exports.alignParserFromContent = alignParserFromContent;
exports.default = alignParser;
